exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonify/index.js
 ** module id = 260
 ** module chunks = 0
 **/